import * as Types from './types';
import axios from 'axios';
import { AppConfig } from 'AppConfig';
import { store } from 'store/store';
import * as FoTypes from 'features/frontoffice/actions/types';
import * as FoAction from 'features/frontoffice/actions/actions';
import * as CustomAction from 'features/frontoffice/customReport/actions/action';
import { requestWithTenantSwitchRetry } from 'networking/tenantSwitchRetry';

export const SHOULD_REFRESH_INIT_VALUE = 0;

export const getFavoriteReport = () => {
  return (dispatch) => {
    // Return the axios promise so callers can await this thunk
    dispatch({
      type: Types.GET_REPORT_BY_USER_ID_REQUEST
    });
    return requestWithTenantSwitchRetry(() =>
      axios.get(AppConfig.FO_INITIAL_URL + `/favorite-report`)
    )
      .then((m) => {
        let response = m.data;

        if (response && Array.isArray(response)) {
          response = response.filter((item) => item != null);
          response.forEach((item) => (item.favorited = true));
        }
        dispatch({
          type: Types.GET_REPORT_BY_USER_ID_SUCCESS,
          data: response
        });
        return response;
      })
      .catch((err) => {
        // propagate error
        dispatch({
          type: Types.GET_REPORT_BY_USER_ID_FAILURE,
          payload: 'Could not find favorite reports.'
        });
        throw err;
      });
  };
};

export const addFavoriteReport = (reportId, refreshReporttype, shouldRefresh = true) => {
  return (dispatch) => {
    // Keep items in Recently Viewed while toggling favorites.
    store.dispatch({
      type: FoTypes.SET_REPORT_FAVORITED_LOCAL,
      payload: { reportId, favorited: true }
    });
    // Return the axios promise so callers can await completion
    const isAdHoc = refreshReporttype === AppConfig.AD_HOC_CAROUSEL || refreshReporttype?.startsWith('adHoc');
    const uri = isAdHoc ? '/favorite-report/workbook/id/' : '/favorite-report/id/';
    return axios
      .post(AppConfig.FO_INITIAL_URL + `${uri}${reportId}`)
      .then((res) => {
        if (shouldRefresh) {
          refreshReport(refreshReporttype);
          dispatch(getFavoriteReport());
        }
        return res;
      })
      .catch((err) => {
        store.dispatch({
          type: FoTypes.SET_REPORT_FAVORITED_LOCAL,
          payload: { reportId, favorited: false }
        });
        // propagate error
        throw err;
      });
  };
};

export const deleteFavoriteReport = (reportId, refreshReporttype, category, shouldRefresh = true) => {
  return (dispatch) => {
    // Keep items in Recently Viewed while toggling favorites.
    store.dispatch({
      type: FoTypes.SET_REPORT_FAVORITED_LOCAL,
      payload: { reportId, favorited: false }
    });
    const isAdHoc = refreshReporttype === AppConfig.AD_HOC_CAROUSEL || refreshReporttype?.startsWith('adHoc') || category === AppConfig.REPORT_CATEGORY.AD_HOC.code;
    const uri = isAdHoc ? '/favorite-report/workbook/' : '/favorite-report/report/';
    // Return the axios promise so callers can await completion
    return axios
      .delete(AppConfig.FO_INITIAL_URL + `${uri}${reportId}`)
      .then((res) => {
        if (shouldRefresh) {
          refreshReport(refreshReporttype);
          dispatch(getFavoriteReport());
        }
        return res;
      })
      .catch((err) => {
        store.dispatch({
          type: FoTypes.SET_REPORT_FAVORITED_LOCAL,
          payload: { reportId, favorited: true }
        });
        // propagate error
        throw err;
      });
  };
};

export const getTopFavoriteReports = () => {
  return (dispatch) => {
    dispatch({
      type: Types.GET_TOP_FAVORITE_REPORTS_REQUEST
    });
    return requestWithTenantSwitchRetry(() =>
      axios.get(AppConfig.FO_INITIAL_URL + `/favorite-report/top`)
    )
      .then((response) => {
        dispatch({
          type: Types.GET_TOP_FAVORITE_REPORTS_SUCCESS,
          data: response.data
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: Types.GET_TOP_FAVORITE_REPORTS_FAILURE
        });
        console.error('Error fetching top favorite reports:', error);
        throw error;
      });
  };
};

export const setCurrentMenuItem = (item) => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_CURRENT_SELECTED_MENU,
      data: item
    });
  };
};

export const setStandardSelectedTags = (codes) => ({
  type: Types.SET_STANDARD_SELECTED_TAGS,
  data: Array.isArray(codes) ? [...codes] : []
});

// Future Optimization: grab just the selected report type
const refreshReport = (refreshReporttype) => {
  switch (refreshReporttype) {
    case AppConfig.REPORT_CATEGORY.LEGACY.code:
      store.dispatch(FoAction.getStandardReport());
      break;
    case AppConfig.REPORT_CATEGORY.CUSTOM.code:
      store.dispatch(CustomAction.fetchCustomReports());
      break;
    case AppConfig.REPORT_CATEGORY.SMART.code:
    case AppConfig.REPORT_CATEGORY.EXPLORER.code:
      // Favorited state is updated optimistically in the FO reducer.
      // Skip the heavy /user/fo-detail refetch to avoid regenerating all smart-card thumbnails.
      break;
    case AppConfig.REPORT_CATEGORY.AD_HOC.code:
      store.dispatch(FoAction.getSaved());
      break;
    case AppConfig.CUSTOM_CAROUSEL:
      store.dispatch(CustomAction.fetchCustomReports());
      break;
    default:
      store.dispatch(getFavoriteReport());
  }
};